import {
  Button,
  Checkbox,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Paper,
  Dialog,
  DialogActions,
  IconButton,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React, { Fragment } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";

import Snackbar from "../snackbar";
import { styles } from "./style";
import Loading from "../loading";
import InputFileReader from "../fileReader";
import NumberFormatCustom from "../numberFormat";
import Slide from "@material-ui/core/Slide";
import PopupInterface from "../popUpInterface";
function Transition(props) {
  return <Slide direction="down" {...props} />;
}
/*---Mui---*/
// ---Components---/
/*---styles---*/
class Module extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      moduleRole: {},
      openDialogs: this.props.flagOpen || false,
    };
  }

  componentDidMount() {
    this.props.onRef(this);
  }
  handleChange = (name, action) => (event) => {
    // var state = this.state.moduleRole;
    // state[name][action] = event.target.checked === true ? 1 : 0;
    // this.setState({ state });
  };
  handleDialogClose = () => {
    this.PopupInterface.handleDialogClose();
  };
  handleDialogOpen = () => {
    this.PopupInterface.handleDialogOpen();
  };
  render() {
    const { classes, i18next, t, moduleRole, user } = this.props;
    const { editEmployee } = this.state;
    var arraymoduleRole;
    var modules = [];
    var modulesValues;
    var modulesValuesDashboard = { active: 0, exp: "" };
    var diffDays = "";
    if (
      moduleRole !== null &&
      moduleRole !== undefined &&
      Object.values(moduleRole)[0] !== undefined
    ) {
      arraymoduleRole = moduleRole;
      modules = Object.keys(arraymoduleRole);
      modulesValues = Object.values(arraymoduleRole);
      modulesValuesDashboard = modulesValues[0];
      var expdate = modulesValuesDashboard.exp;
      var today = new Date();
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      diffDays = Math.round(
        Math.abs((new Date(expdate).getTime() - today.getTime()) / oneDay)
      );
    }
    return (
      <PopupInterface
        onRef={(dialog) => (this.PopupInterface = dialog)}
        // flagOpen = {false}
        handleDialogClose={this.handleDialogClose}
      >
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        <Loading onRef={(id) => (this.loading = id)} />
        <DialogTitle
          id="scroll-dialog-title"
          disableTypography
          className={classes.DialogTitle}
        >
          <Typography variant="h2" className={classes.title}>
            {t("Module role of owner spa")}
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.DialogContent}>
          <Paper className={classes.root}>
            <Grid container style={{ marginLeft: 17 }}>
              {modules.map((m, index) => {
                if (
                  m === "employee" ||
                  m === "album" ||
                  m === "menu" ||
                  m === "discount" ||
                  m === "voucher" ||
                  m === "customer" ||
                  m === "booking" ||
                  m === "order" ||
                  m === "branch" ||
                  m === "stableCost"
                ) {
                  return (
                    <Grid item xs={4} sm={3} md={2} key={index}>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <FormLabel
                          component="legend"
                          className={classes.formLabel}
                        >
                          {t("sidebar_" + m)}
                        </FormLabel>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  modulesValues[index].list === 1 ? true : false
                                }
                                onChange={this.handleChange(m, "list")}
                                value="list"
                              />
                            }
                            className={classes.label}
                            label="View list"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  modulesValues[index].add === 1 ? true : false
                                }
                                onChange={this.handleChange(m, "add")}
                                value="add"
                              />
                            }
                            className={classes.label}
                            label="Add"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  modulesValues[index].remove === 1
                                    ? true
                                    : false
                                }
                                onChange={this.handleChange(m, "remove")}
                                value="remove"
                              />
                            }
                            className={classes.label}
                            label="Remove"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  modulesValues[index].edit === 1 ? true : false
                                }
                                onChange={this.handleChange(m, "edit")}
                                value="edit"
                              />
                            }
                            className={classes.label}
                            label="Edit"
                          />
                        </FormGroup>
                      </FormControl>
                    </Grid>
                  );
                } else if (m === "employee" || m === "service") {
                  return (
                    <Grid item xs={4} sm={3} md={2} key={index}>
                      <FormControl
                        component="fieldset"
                        className={classes.formControl}
                      >
                        <FormLabel
                          component="legend"
                          className={classes.formLabel}
                        >
                          {t("sidebar_" + m)}
                        </FormLabel>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  modulesValues[index].list === 1 ? true : false
                                }
                                onChange={this.handleChange(m, "list")}
                                value="list"
                              />
                            }
                            className={classes.label}
                            label="View list"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  modulesValues[index].detail === 1
                                    ? true
                                    : false
                                }
                                onChange={this.handleChange(m, "detail")}
                                value="detail"
                              />
                            }
                            className={classes.label}
                            label="View detail"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  modulesValues[index].edit === 1 ? true : false
                                }
                                onChange={this.handleChange(m, "edit")}
                                value="edit"
                              />
                            }
                            className={classes.label}
                            label="Edit"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  modulesValues[index].add === 1 ? true : false
                                }
                                onChange={this.handleChange(m, "add")}
                                value="add"
                              />
                            }
                            className={classes.label}
                            label="Add"
                          />
                        </FormGroup>
                      </FormControl>
                    </Grid>
                  );
                }
              })}
              <Grid item xs={4} sm={3} md={2}>
                <FormControl
                  component="fieldset"
                  className={classes.formControl}
                >
                  <FormLabel component="legend" className={classes.formLabel}>
                    {t("sidebar_" + modules[0])}{" "}
                  </FormLabel>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            modulesValuesDashboard.active === 1 ? true : false
                          }
                          onChange={this.handleChange(modules[0], "active")}
                          value="active"
                        />
                      }
                      className={classes.label}
                      label="Active"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              {diffDays <= 5 && diffDays !== null && diffDays > 0 ? (
                <div className={classes.containerExp}>
                  <div className={classes.square}></div>
                  <div className={classes.arrowRight}></div>
                  <Typography variant="body1" className={classes.titleLeft}>
                    {t(
                      "employees_listemployee_editemployee_editcontent_employee_notification"
                    )}
                  </Typography>
                  <Typography variant="body1" className={classes.titleRight}>
                    Module <b className={classes.nameModule}>{modules[0]}</b>{" "}
                    {t(
                      "employees_listemployee_editemployee_editcontent_employee_will_expire_in"
                    )}{" "}
                    <b>
                      {diffDays}{" "}
                      {t(
                        "employees_listemployee_editemployee_editcontent_days"
                      )}
                    </b>
                    {t("employees_listemployee_editemployee_editcontent_click")}{" "}
                    <a className={classes.link}>
                      {t(
                        "employees_listemployee_editemployee_editcontent_here"
                      )}
                    </a>{" "}
                    {t(
                      "employees_listemployee_editemployee_editcontent_to_update"
                    )}{" "}
                  </Typography>
                </div>
              ) : (
                ""
              )}
            </Grid>
          </Paper>
        </DialogContent>
        <DialogActions classes={{ root: classes.rootDialogActions }}>
          <IconButton
            aria-label="Close"
            size="small"
            className={classes.marginCloseButton}
            onClick={this.props.handleDialogClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogActions>
      </PopupInterface>
    );
  }
}

const mapState = (state) => ({
  moduleRole:
    state.user && state.user.user && state.user.user.roleId
      ? state.user.user.roleId.module
      : null,
  user: state.user,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: 0 })(Module)));
